export class ListItem<T> {
  public checked = false;

  public constructor(public readonly item: T) {}
}
